import {
  Component,
  OnDestroy,
  ViewContainerRef,
} from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Subscription } from 'rxjs'
import { FILTER_MAP, MANAGEMENT_STYLE_FILTERS } from 'src/app/models/filter-details.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { FiltersService } from 'src/app/services/filtersService.service'

@Component({
  selector: 'management-style-filter',
  templateUrl: './managementStyleFilter.component.html',
  styleUrls: ['./managementStyleFilter.component.scss'],
})
export class ManagementStyleFilterComponent implements OnDestroy {

  // AEM content Vars
  managementStyle: AEMChunk
  aemContentSub: Subscription
  isNonVanguard: boolean
  // eslint-disable-next-line max-params
  constructor(
    private readonly filtersService: FiltersService,
    private readonly viewContainer: ViewContainerRef,
    //  private readonly contentService: ContentService,
    private readonly centralContentService: CentralContentService,
  ) {}
  
  public readonly filterMap = FILTER_MAP
  public readonly managementStyleFilterLabels = MANAGEMENT_STYLE_FILTERS
  public managementStyleGroup: UntypedFormGroup
  ngOnInit() {
    this.managementStyleGroup = this.filtersService.activeFilters.managementStyle
    this.managementStyleGroup.valueChanges.subscribe(() => {
      this.filtersService.applyFilters()
    })
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.managementStyle = this.centralContentService.getContentByBody(
      'fund_definitions_whats_a_management_style',
      content,
    )
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
